import { useEffect, useRef } from 'react';

function useIntersectionObserver({
  root,
  target,
  threshold = 1.0,
  rootMargin = '0px',
  enabled = true,
  canTriggerOnMount = true,
  onIntersect,
}) {
  const mounted = useRef(false);

  useEffect(() => {
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (!enabled || (!canTriggerOnMount && !mounted.current)) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) =>
        entries.forEach(
          ({ isIntersecting }) => isIntersecting && onIntersect()
        ),
      {
        root: root && root.current,
        rootMargin,
        threshold,
      }
    );

    const elem = target && target.current;

    if (!elem) {
      return;
    }

    observer.observe(elem);

    return () => {
      observer.unobserve(elem);
    };
  }, [target.current, enabled, mounted.current]);
}

export default useIntersectionObserver;
